module.exports = __webpack_public_path__ + "img/invoice-de-male-by.c140ae0d.png";